import {
  ContentfulRichTextGatsbyReference,
  renderRichText,
  RenderRichTextData,
} from 'gatsby-source-contentful/rich-text'
import React from 'react'
import { classNames, cn } from '../utils'

interface ValuePropProps {
  subTitle?: string
  title: string
  description?: Partial<RenderRichTextData<ContentfulRichTextGatsbyReference>>
  vertical?: boolean
  longTitle?: boolean
}

export const ValueProp = ({
  subTitle,
  title,
  description,
  vertical,
  longTitle,
}: ValuePropProps) => {
  return (
    <div
      className={cn(
        'col-span-full grid grid-cols-subgrid',
        vertical && 'mb-8 md:mb-20'
      )}
    >
      <div className="col-span-full row-start-1 row-end-2 flex flex-col">
        {subTitle && (
          <h3 className="mb-l pl-m text-xl text-primary-400">{subTitle}</h3>
        )}
      </div>
      <div
        className={cn(
          'col-span-full flex flex-col md:col-span-5',
          longTitle
            ? 'row-start-4 row-end-5 md:row-start-3 md:row-end-4'
            : 'row-start-2 row-end-3'
        )}
      >
        <h2
          className={cn(
            `header-highlight relative mb-8 pl-m text-3xl font-bold leading-normal`,
            'text-default-50'
          )}
        >
          {title}
        </h2>
      </div>
      {description && (
        <div
          className={cn(
            'col-span-full md:col-span-7',
            vertical
              ? 'row-start-5 row-end-6 md:row-start-4 md:row-end-5'
              : 'row-start-3 row-end-4 md:row-start-2 md:row-end-3'
          )}
        >
          <div
            className={classNames('value-prop-description', 'text-default-50')}
          >
            {renderRichText(description)}
          </div>
        </div>
      )}
    </div>
  )
}
